import { render, staticRenderFns } from "./promocode.vue?vue&type=template&id=ebfd36aa&"
import script from "./promocode.vue?vue&type=script&lang=js&"
export * from "./promocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports